import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SettingsTabLabelComponent } from './settings-tab-label.component';

import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

@NgModule({
  declarations: [SettingsTabLabelComponent],
  imports: [CommonModule, RouterModule, MatIconModule, TranslocoDirective],
  exports: [SettingsTabLabelComponent],
})
export class SettingsTabLabelModule {}
